import Case from '../Case/Case';
import { childrenToStrings } from '../ChildrenToStrings/ChildrenToStrings';
import { CapitalizeProps } from './Capitalize.type';

const Capitalize = ({ ariaLabel, children }: CapitalizeProps) => {
    return (
        <Case ariaLabel={ariaLabel} caseType={'capitalize'}>{childrenToStrings(children)}</Case>
    );
};

export default Capitalize;